import {
    type ApiEndpoint,
    type DownloadUrlResponse,
    isDownloadUrlResponse,
} from "@/shared/api-endpoint";
import { isObject } from "@/shared/utils/typeGuards";

export const kVariations25Route = "/variations-2.5";

export interface Variations25RequestBody {
    fileKey: string;
    bpm: number;
    pitchPalette?: number[];
    complexity?: number;
    naturalness?: number;
    uniformity?: number;
    transposition?: number;
    seed?: number;
    secondsEnd?: number;
}

export const isVariations25RequestBody = (value: unknown): value is Variations25RequestBody =>
    isObject(value) && typeof value.fileKey === "string" && typeof value.bpm === "number";

export const kVariations25Endpoint: ApiEndpoint<Variations25RequestBody, DownloadUrlResponse> = {
    route: kVariations25Route,
    label: "Variations 2.5",
    source: "Modal",
    category: "SpliceGen v2.5",
    description: "Variations using the SpliceGen 2.5 model for richer harmonic expression.",
    isRequestBody: isVariations25RequestBody,
    isSuccessResponse: isDownloadUrlResponse,
};
